import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-skip-link',
  standalone: true,
  imports: [TranslocoPipe],
  template: `
    <a href="#main-content" class="skip-link sr-only">
      {{ 'common.skipToContent' | transloco }}
    </a>
  `,
})
export class SkipLinkComponent {}
